import { render, staticRenderFns } from "./storeLink.vue?vue&type=template&id=2e3c2422&scoped=true"
import script from "./storeLink.vue?vue&type=script&lang=js"
export * from "./storeLink.vue?vue&type=script&lang=js"
import style0 from "./storeLink.vue?vue&type=style&index=0&id=2e3c2422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3c2422",
  null
  
)

export default component.exports